export const Events = {
  omicsExplorer: {
    navigateToOE: 'Navigated to Omics Explorer',
    navigateToOmicsSummary: 'Navigated to Omics Summary',
    tumorSitePredictionPopover: 'Opened "TumorSite Prediction" popover',
    variantRowClick: 'Clicked variant row item',
    variantDetailTabs: {
      details: 'Clicked Details tab',
      gene: 'Clicked Gene tab',
      transcripts: 'Clicked Transcripts tab',
      needlePlot: 'Clicked Needle Plot tab',
      jaxCancerEffect: 'Clicked Jax Cancer Effect tab',
      jaxGeneDrugEvidence: 'Clicked Jax Gene-Drug Evidence Tab',
      drugs: 'Clicked CKB tab',
      cancerPrevalence: 'Clicked Cancer Prevalence Tab',
      expressionPlots: 'Clicked Reference Tissue Expression Tab',
    },
  },
};
